export * from './applied-promotions';
export function omitAppliedPromotions(_ref) {
  let {
    applicablePromotions,
    appliedPromotions
  } = _ref;

  if (!(applicablePromotions !== null && applicablePromotions !== void 0 && applicablePromotions.length)) {
    return [];
  }

  if (!(appliedPromotions !== null && appliedPromotions !== void 0 && appliedPromotions.length)) {
    return applicablePromotions;
  }

  return applicablePromotions.filter(promotion => !appliedPromotions.find(ap => ap.campaignId === promotion.campaignId));
}